module.exports = __webpack_public_path__ + "img/shellchart.6a6a0d73.png";